import AddIcon from '@mui/icons-material/AddCircle';
import {AppBar, Button, CardActions, Divider, Tooltip} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {TOUR_STAGES} from '@explorer/constants';

const Footer = props => {
  const {t} = useTranslation();

  const onAPIClick = () => {
    props.openApiDialog();
  };

  return (
    <AppBar position="static" elevation={0} color="inherit">
      <Divider />
      <CardActions
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Button color="primary" onClick={onAPIClick} data-cy="api-button">
          {t('resultsFooter.buttonApiDetails')}
        </Button>
        <Tooltip
          title={
            props.count === 0 ? t('resultsFooter.tooltipSelectToOrder') : ''
          }
        >
          <span>
            <Button
              color="primary"
              variant="contained"
              startIcon={<AddIcon fontSize="small" />}
              disabled={props.count === 0}
              onClick={props.onOrderClick}
              data-qe="order-button"
              data-tour={TOUR_STAGES.ORDER_BUTTON}
            >
              {t('resultsFooter.order', {
                count: props.count,
              })}
            </Button>
          </span>
        </Tooltip>
      </CardActions>
    </AppBar>
  );
};

Footer.propTypes = {
  count: PropTypes.number,
  onOrderClick: PropTypes.func,
  openApiDialog: PropTypes.func,
};

export default Footer;
